import { Popup } from "react-map-gl";
import { useTranslation } from "react-i18next";
import type { PopupInfo } from "@/stores/mapStore";

interface MapPopupProps {
  info: PopupInfo;
  onClose: () => void;
  onAskAbout: (entityType: string, entityId: string, name: string) => void;
}

const ASK_KEYS: Record<string, string> = {
  property: "map.askAboutProperty",
  project: "map.askAboutProject",
  permit: "map.askAboutPermit",
  tender: "map.askAboutTender",
};

export function MapPopup({ info, onClose, onAskAbout }: MapPopupProps) {
  const { t } = useTranslation();
  const typeLabel = t(`map.entityTypes.${info.entityType}`, info.entityType);
  const askText = t(ASK_KEYS[info.entityType] ?? "map.askAbout");

  return (
    <Popup
      longitude={info.longitude}
      latitude={info.latitude}
      anchor="bottom"
      closeButton={false}
      closeOnClick={false}
      onClose={onClose}
      offset={16}
      maxWidth="280px"
      className="cx-map-info-card"
    >
      <div className="cx-popup-container">
        {/* Header: entity type + close */}
        <div className="cx-popup-header">
          <span className="cx-popup-type">{typeLabel}</span>
          <button
            className="cx-popup-close"
            onClick={onClose}
            aria-label={t("common.close", "Close")}
          >
            ×
          </button>
        </div>

        {/* Name */}
        <div className="cx-popup-name">{info.name || info.entityId}</div>

        {/* Municipality */}
        {info.municipality && (
          <div className="cx-popup-municipality">{info.municipality}</div>
        )}

        {/* Contextual ask link */}
        <button
          className="cx-popup-ask"
          onClick={() => onAskAbout(info.entityType, info.entityId, info.name)}
        >
          {askText} <span className="cx-popup-ask-arrow">→</span>
        </button>
      </div>
    </Popup>
  );
}
